import { render, staticRenderFns } from "./HowItWork.vue?vue&type=template&id=6c7b2328&scoped=true"
import script from "./HowItWork.vue?vue&type=script&lang=js"
export * from "./HowItWork.vue?vue&type=script&lang=js"
import style0 from "./HowItWork.vue?vue&type=style&index=0&id=6c7b2328&prod&lang=css&scoped=true"
import style1 from "./HowItWork.vue?vue&type=style&index=1&id=6c7b2328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7b2328",
  null
  
)

export default component.exports